// Components & Data Imports
import Footer from '../layout/Footer'
import MapIframe from '../components/MapIframe'
import Map1 from '../resources/imgs/map1.webp'
import Map2 from '../resources/imgs/map2.webp'

// Icons
import { FaCampground } from 'react-icons/fa6'
import { RiContactsBook3Fill, RiBuilding4Fill } from 'react-icons/ri'

const Contact = () => {
  return (
    <>
      <div className='contact'>
        <div className='news-bg'></div>
        <div className='news-heading'>
          <RiContactsBook3Fill className='news-heading-icon' />
          <div className='news-heading-title'>Kontakty</div>
          <div className='news-heading-subtitle'>Kde nás najdete</div>
        </div>
        <div className='contact-heading'>
          <RiBuilding4Fill className='contact-icon' />
          <div className='contact-title'>Sídlo organizace</div>
        </div>
        <div className='contact-general'>
          <div className='contact-general-info'>
            <div className='contact-general-person'>
              <p className='contact-mar-b'>
                <span>Kontaktní osoba</span>
              </p>
              <p>Hana Pelcová</p>
              <p>hlavní vedoucí</p>
              <p>info@hlavas.org</p>
              <p>+420 739 001 411</p>
            </div>
            <div className='contact-general-address'>
              <p className='contact-mar-b'>
                <span>Hlavas z.s.</span>
              </p>
              <p>Nademlejnská 651/7</p>
              <p>198 00 Praha 9 - Hloubětín</p>
              <p className='contact-mar-b'>IČ: 095 92 954</p>
              <p>ČÚ: 123-3451350257/0100</p>
              <a
                href='https://or.justice.cz/ias/ui/rejstrik-firma.vysledky?subjektId=1101405&typ=PLATNY'
                target='blank'
              >
                Výpis z rejstříku &rarr;
              </a>
            </div>
          </div>
          <div className='contact-general-map'>
            <MapIframe
              placeholderSrc={Map1}
              className='contact-general-map-settings'
              title='sidlo'
              src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2559.1218456795277!2d14.525665716188152!3d50.10272627942896!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x470bed2a6ca216e9%3A0xd97ac56f2ccbd01c!2sNademlejnsk%C3%A1%20651%2C%20198%2000%20Praha%209-Hloub%C4%9Bt%C3%ADn!5e0!3m2!1scs!2scz!4v1650889887304!5m2!1scs!2scz'
            />
          </div>
        </div>
        <div className='contact-heading contact-heading-2'>
          <FaCampground className='contact-icon' />
          <div className='contact-title'>Táborová základna</div>
        </div>
        <div className='contact-camp'>
          <div className='contact-camp-info'>
            <div className='contact-camp-address'>
              <p className='contact-mar-b'>
                <span>Korespondenční adresa</span>
              </p>
              <p>LDT Radostné Mládí</p>
              <p>Osada Vrábov</p>
              <p>257 26 Český Šternberk</p>
            </div>
          </div>

          <div className='contact-camp-map'>
            <MapIframe
              placeholderSrc={Map2}
              className='contact-camp-map-settings'
              title='tabor'
              src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d8477.959317070676!2d14.932615593644066!3d49.81751628667765!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x470c64bde48ed4dd%3A0x2e83576f81c46c20!2zUmVrcmVhxI1uw60gb2JqZWt0IFJhZG9zdG7DqSBNbMOhZMOt!5e0!3m2!1scs!2scz!4v1736323392240!5m2!1scs!2scz'
            />
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}

export default Contact
